import React, { useCallback } from 'react';
import { Button, Link, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { Picture } from "../Picture";
import { RequestStatusWrap } from "./RequestStatusWrap";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var RequestStatus = function RequestStatus(_ref) {
  var _button$size, _button$variant, _button$size2, _button$variant2, _buttonReject$size, _buttonReject$variant;
  var img = _ref.img,
    title = _ref.title,
    imgWidth = _ref.imgWidth,
    description = _ref.description,
    button = _ref.button,
    buttonReject = _ref.buttonReject,
    onConfirm = _ref.onConfirm,
    onReject = _ref.onReject,
    onCloseModal = _ref.onCloseModal,
    withModal = _ref.withModal;
  var onCloseModalCallBack = useCallback(function () {
    if (!onCloseModal && onConfirm) {
      onConfirm();
      return;
    }
    if (onCloseModal) {
      onCloseModal();
    }
  }, [onConfirm, onCloseModal]);
  return /*#__PURE__*/React.createElement(RequestStatusWrap, {
    button: button,
    buttonReject: buttonReject,
    onClose: onCloseModalCallBack,
    onConfirm: onConfirm,
    onReject: onReject,
    withModal: withModal
  }, /*#__PURE__*/React.createElement(React.Fragment, null, img && /*#__PURE__*/React.createElement("div", {
    className: cn('img'),
    style: imgWidth ? {
      width: imgWidth
    } : undefined
  }, /*#__PURE__*/React.createElement(Picture, img)), title && /*#__PURE__*/React.createElement("div", {
    className: cn('title')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size3-m"
  }, title)), description && /*#__PURE__*/React.createElement("div", {
    className: cn('description')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey95",
    size: "size4-r"
  }, description)), (button === null || button === void 0 ? void 0 : button.text) && !withModal && /*#__PURE__*/React.createElement("div", {
    className: cn('action', {
      'action--with-full-width': buttonReject && onReject
    })
  }, (button === null || button === void 0 ? void 0 : button.url) && /*#__PURE__*/React.createElement(Link, {
    buttonSize: (_button$size = button === null || button === void 0 ? void 0 : button.size) !== null && _button$size !== void 0 ? _button$size : 'm',
    buttonVariant: (_button$variant = button === null || button === void 0 ? void 0 : button.variant) !== null && _button$variant !== void 0 ? _button$variant : 'tertiary',
    href: button.url,
    size: "size5-m",
    variant: "button"
  }, button.text), !(button !== null && button !== void 0 && button.url) && onConfirm && /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    size: (_button$size2 = button === null || button === void 0 ? void 0 : button.size) !== null && _button$size2 !== void 0 ? _button$size2 : 'm',
    variant: (_button$variant2 = button === null || button === void 0 ? void 0 : button.variant) !== null && _button$variant2 !== void 0 ? _button$variant2 : 'tertiary'
  }, button.text), !!buttonReject && onReject && /*#__PURE__*/React.createElement("div", {
    className: cn('reject-wrapper')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onReject,
    size: (_buttonReject$size = buttonReject === null || buttonReject === void 0 ? void 0 : buttonReject.size) !== null && _buttonReject$size !== void 0 ? _buttonReject$size : 'm',
    variant: (_buttonReject$variant = buttonReject === null || buttonReject === void 0 ? void 0 : buttonReject.variant) !== null && _buttonReject$variant !== void 0 ? _buttonReject$variant : 'tertiary'
  }, buttonReject.text)))));
};
export { RequestStatus };